//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: ${({ height }) => height};
    margin: 0 25px;
    gap: 10px;
    border: 0;
    &::after {
        content: "";
        background-color: var(--purple-4);
        width: 1px;
        height: 100%;
    }
`;